import { Box } from '@mui/system';
import React from 'react';

const BackgroundWrapper = ({ currentPath, pagesWithBackground, backgroundImage, images, children }) => {
  const backgroundStyle = pagesWithBackground?.includes(currentPath)
    ? {
        // backgroundImage: "url(https://images.pexels.com/photos/4913802/pexels-photo-4913802.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh", // Ensures full viewport height coverage
        display: "flex",
        flexDirection: "column", // Column layout for content and footer alignment
        justifyContent: "space-between", // Pushes footer to the bottom
      }
    : {
        backgroundImage: backgroundImage
          ? "url(" + (images?.find((val) => val.id === backgroundImage)?.image || "") + ")"
          : "",
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      };

  return (
    <Box id="main" style={backgroundStyle}>
      <Box style={{ flex: 32 }}>
        {children} {/* Main content area */}
      </Box>
    </Box>
  );
};

export default BackgroundWrapper;
